<section class="app_commonPage__container">
  <app-cx-brand-color-bar></app-cx-brand-color-bar>
  <app-header></app-header>
  <section class="app_commonPage_body">
    <app-aside></app-aside>
    <section id="content">
      <div *ngIf="!isConnected" class="app_commonPage_body_alert print_hide-on-print">
        <div *ngIf="!timeSixHoursBefore">
          <p-messages severity= info >
            <ng-template pTemplate>
              <div class="p-ml-2">
                <i class="pi pi-info-circle" style="margin-right: 10px"></i>
                <strong>{{buildMessageOfflineExpiration()}}</strong></div>
            </ng-template>
          </p-messages>
        </div>
        <div *ngIf="timeSixHoursBefore">
          <p-messages severity= error >
            <ng-template pTemplate>
              <div class="p-ml-2">
                <i class="pi pi-info-circle" style="margin-right: 10px"></i>
                <strong>{{buildMessageOfflineExpiration()}}</strong></div>
            </ng-template>
          </p-messages>
        </div>
      </div>
      <div class="app_commonPage_body_alert">
        <p-messages key="examen" id="p-message"></p-messages>
      </div>
      <span id="messageContent">
        <section *ngIf="visibilitySuccsessAlert" class="app_commonPage_body_alert" tag="alert">
          <app-cx-alerts
            messageText="{{ messageSuccsessAlert }}"
            type="success"
          ></app-cx-alerts>
        </section>
        <section *ngIf="visibilityWarnAlert" class="app_commonPage_body_alert" tag="alert">
          <app-cx-alerts
            messageText="{{ messageWarnAlert }}"
            type="warn"
          ></app-cx-alerts>
        </section>
        <section *ngIf="visibilityInfoAlert" class="app_commonPage_body_alert" tag="alert">
          <app-cx-alerts
            messageText="{{ messageInfoAlert }}"
            type="info"
          ></app-cx-alerts>
        </section>
      </span>
      <router-outlet></router-outlet>
    </section>
  </section>
  <app-modal id="modal"></app-modal>
  <app-footer style="position: absolute;"></app-footer>
</section>


<p-confirmDialog
  #cd
  [message]="'Lo sentimos, su sesión ha expirado.'"
  [(visible)]="timedOut"
  [closable]="false"
  [style]="{ width: '500px' }"
  styleClass="p-dialog-custom"
>
<p-footer>
  <button
    (click)="logout()"
    label="Aceptar"
    pButton
    type="button"
  ></button>
</p-footer>
</p-confirmDialog>
